import React from 'react';
import { useOrganization } from '../contexts/OrganizationContext';

export const OrganizationSwitchLoader: React.FC = () => {
  const { isSwitching } = useOrganization();
  
  if (!isSwitching) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-xl">
        <div className="flex items-center space-x-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <p className="text-lg font-medium">Switching organization...</p>
        </div>
      </div>
    </div>
  );
};